import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Prompt, StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import mealsStore from '../../store/mealsStore';
import MealMainDetails from '../MealMainDetails/MealMainDetails';
import MealProducts from '../MealProducts/MealProducts';
import { SCREENS } from 'src/constants/screens';
import integrationStore from 'src/mobx/integrationStore';
import { localeStore } from 'src/mobx/localesStore';
import { getTranslate, scrollToErrorElement } from 'src/utils/helpers';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { getPromptProps } from 'src/view/components/CustomPrompt/helper';
import ItemImages from 'src/view/components/ItemImages/ItemImages';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import Headers from 'src/view/containers/Headers/Headers';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { BUTTON_TITLE } from '~/constants/main';

type TProps = RouteComponentProps<{ id?: string }, StaticContext, undefined>;

const MealsEdit: React.FC<TProps> = observer((props: TProps): JSX.Element => {
  useEffect(() => {
    if (!mealsStore.mealsCount) mealsStore.fetchMealsCount();

    if (props.match.params.id) {
      mealsStore.setMeal(mealsStore.pagination.data.find((meal) => meal.id === Number(props.match.params.id)));

      if (!mealsStore.meal?.id) mealsStore.getMeal(props.match.params.id);
      return;
    }

    mealsStore.setMeal();
  }, []);

  const clickSave = () => {
    if (!mealsStore.meal) return;
    mealsStore.setValidation();

    if (!mealsStore.validation.valid) {
      scrollToErrorElement();
      return;
    }

    save();
  };

  const save = () => {
    const { meal, createMeal, updateMeal } = mealsStore;
    if (!meal) return;

    if (meal.is_draft) {
      createMeal();
    } else {
      updateMeal(meal.id);
    }
  };

  return (
    <>
      <Headers>
        <HeaderBack title={mealsStore.meal ? getTranslate(mealsStore.meal.name) : ''} noTranslation path={SCREENS.MEALS()} />
      </Headers>
      <ScrollableBlock showScrollbar className="full-height mt-6">
        <ItemImages
          currentSaveImage={mealsStore.meal?.image}
          currentSaveImages={mealsStore.meal?.images}
          //
          images={mealsStore.images}
          validation={mealsStore.validation.images}
          draggableImage={mealsStore.draggableImage}
          posRestrictions={integrationStore.posRestrictions?.comboMealImage}
          uploadImage={mealsStore.uploadImage}
          deleteImage={mealsStore.deleteImage}
          imagesChangesSubmit={mealsStore.imagesChangesSubmit}
          setValidation={mealsStore.setValidation}
          setDraggableImage={mealsStore.setDraggableImage}
          handleDragEnd={mealsStore.handleDragEnd}
        />
        <MealMainDetails />
        <MealProducts />
        <Button title={localeStore.t(BUTTON_TITLE.SAVE)} onClick={clickSave} loading={mealsStore.isLoading} className="mt-8" />
      </ScrollableBlock>
      <LoadingOverlay visible={mealsStore.isLoading} />
      <Prompt when={mealsStore.edited} message={getPromptProps()} />
    </>
  );
});

export default MealsEdit;
